// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__CEsqs","title":"ClientCherryInfo_title__3nTV1","itemText":"ClientCherryInfo_itemText__3ozxF"};